export default "__VITE_ASSET__H4el3Rqa__"